"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorMessage = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _qa = require("../../utils/qa");
var _ErrorImages = require("./ErrorImages");
var _ErrorMessageModule = _interopRequireDefault(require("./ErrorMessage.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ErrorMessage = exports.ErrorMessage = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    classNames,
    children,
    imageVariant,
    title,
    description,
    customImageUrl,
    heading,
    testId,
    ...props
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ...props,
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'errorMessage'
    }),
    className: (0, _classify.default)(_ErrorMessageModule.default.wrapper, classNames?.wrapper),
    ref: ref,
    children: [!!imageVariant && !customImageUrl && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      "data-testid": (0, _qa.generateTestId)({
        base: testId,
        slot: 'image'
      }),
      className: (0, _classify.default)(_ErrorMessageModule.default.image, classNames?.image),
      children: [imageVariant === 'unauthorized' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorImages.UnauthorizedImage, {}), imageVariant === 'forbidden' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorImages.ForbiddenImage, {}), imageVariant === 'notFound' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorImages.NotFoundImage, {}), imageVariant === 'serverError' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorImages.ServerErrorImage, {})]
    }), customImageUrl && /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      "data-testid": (0, _qa.generateTestId)({
        base: testId,
        slot: 'image'
      }),
      className: (0, _classify.default)(_ErrorMessageModule.default.image, classNames?.image),
      src: customImageUrl,
      alt: "Empty State"
    }), !!heading && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "data-testid": (0, _qa.generateTestId)({
        base: testId,
        slot: 'heading'
      }),
      className: (0, _classify.default)(_ErrorMessageModule.default.heading, classNames?.heading),
      children: heading
    }), !!title && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "data-testid": (0, _qa.generateTestId)({
        base: testId,
        slot: 'title'
      }),
      className: (0, _classify.default)(_ErrorMessageModule.default.title, classNames?.title),
      children: title
    }), !!description && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "data-testid": (0, _qa.generateTestId)({
        base: testId,
        slot: 'description'
      }),
      className: (0, _classify.default)(_ErrorMessageModule.default.description, classNames?.description),
      children: description
    }), !!children && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "data-testid": (0, _qa.generateTestId)({
        base: testId,
        slot: 'children'
      }),
      className: (0, _classify.default)(_ErrorMessageModule.default.childrenWrapper, classNames?.children),
      children: children
    })]
  });
});